<template>
  <v-container style="padding: 0;">
    <v-dialog v-model="hideShow" width="1240px" persistent content-class="class-detail-dialog">
      <v-card class="cd-shell">
        <header class="cd-header">
          <div class="cd-heading">
            <span class="cd-emblem"><v-icon color="#d9363e" size="28">mdi-google-classroom</v-icon></span>
            <div class="cd-heading-text">
              <div class="cd-title-row"><h2>{{classModel ? classModel.className : '班级详情'}}</h2><span v-if="classModel && classModel.status=='1'" class="cd-status">正常</span><span v-if="classModel && classModel.status=='0'" class="cd-status cd-status-off">已作废</span></div>
              <div v-if="classModel" class="cd-subtitle"><span>{{classModel.courseName}}</span><span>{{consumeTypeName(classModel.consumeType)}}</span></div>
            </div>
          </div>
          <div class="cd-header-actions">
            <template v-if="classModel"><v-btn outlined color="#586a80" @click="showUpdateClass"><v-icon left small>mdi-pencil-outline</v-icon>修改班级</v-btn><v-btn v-if="classModel.consumeType=='2'" depressed color="#d9363e" dark @click="showUpgradeView">升班</v-btn></template>
            <v-btn icon aria-label="关闭班级详情" @click="cancel"><v-icon>mdi-close</v-icon></v-btn>
          </div>
        </header>
        <v-tabs v-model="tab" class="cd-tabs" color="#d9363e" background-color="white"><v-tabs-slider color="#d9363e" /><v-tab>班级信息</v-tab><v-tab>排课明细</v-tab></v-tabs>
        <v-card-text class="cd-scroll">
          <v-tabs-items v-model="tab" class="cd-tab-content">
            <v-tab-item>
              <div v-if="classModel" class="cd-overview">
                <aside class="cd-sidebar">
                  <section class="cd-panel">
                    <div class="cd-section-heading"><h3>教学安排</h3><v-btn text small color="#d9363e" @click="showUpdateTeacher" :disabled="classModel.status !== '1'">修改老师</v-btn></div>
                    <dl class="cd-facts"><div><dt>主课老师</dt><dd>{{classModel.teacherName || '—'}}</dd></div><div v-if="classModel.secondTeacherName"><dt>助教老师一</dt><dd>{{classModel.secondTeacherName}}</dd></div><div v-if="classModel.thirdTeacherName"><dt>助教老师二</dt><dd>{{classModel.thirdTeacherName}}</dd></div><div><dt>上课教室</dt><dd>{{classModel.roomName || '—'}}</dd></div><div><dt>每节课扣课时</dt><dd>{{classModel.reduceQty}} <span>课时</span></dd></div><div><dt>计老师绩效</dt><dd>{{classModel.addTeacherClassCount}} <span>节 / 次</span></dd></div></dl>
                  </section>
                  <section class="cd-panel">
                    <div class="cd-section-heading"><h3>上课时间</h3><v-btn text small color="#d9363e" @click="showUpdateTime">修改时间</v-btn></div>
                    <div class="cd-date-range"><div><span>开课日期</span><strong>{{classModel.dateFrom || '—'}}</strong></div><span class="cd-date-divider">至</span><div><span>结束日期</span><strong>{{classModel.dateTo || '—'}}</strong></div></div>
                    <div v-if="classModel.timePlanList && classModel.timePlanList.length" class="cd-time-list"><div v-for="(plan,idx) in classModel.timePlanList" :key="idx" class="cd-time"><span>{{plan.weekName}}</span><time>{{plan.timeFrom}} – {{plan.timeTo}}</time></div></div><p v-else class="cd-muted">暂无固定上课时间</p>
                  </section>
                  <section class="cd-panel">
                    <div class="cd-section-heading"><h3>班级设置</h3></div>
                    <div class="cd-setting"><div><span class="cd-setting-label">自动送积分</span><p v-if="classModel.autoPoint=='1'">已开启 · {{classModel.autoPointQty}} 积分 / 课次</p><p v-if="classModel.autoPoint=='0'">未开启</p></div><v-btn v-if="classModel.autoPoint=='0'" @click="openAutoPoint" text small color="#d9363e">开启</v-btn><v-btn v-if="classModel.autoPoint=='1'" @click="closeAutoPoint" text small color="#586a80">关闭</v-btn></div>
                    <div class="cd-setting"><div><span class="cd-setting-label">班级状态</span><p v-if="classModel.status=='1'">正常</p><p v-if="classModel.status=='0'">已作废</p></div><v-btn v-if="classModel.status == '1'" @click="frozenClass" text small color="#d9363e">作废班级</v-btn><v-btn v-if="classModel.status == '0'" @click="freeClass" text small color="#d9363e">启用班级</v-btn></div>
                  </section>
                </aside>
                <main class="cd-main">
                  <section class="cd-metrics" aria-label="班级概况"><div><span>现有 / 满班人数</span><strong>{{classModel.studentQty}}<small> / {{classModel.maxQty}} 人</small></strong></div><div><span>总课次</span><strong>{{classModel.totalTimes}}<small> 次</small></strong></div><div><span>已上课次</span><strong>{{classModel.approvedTimes}}<small> 次</small></strong></div><div><span>剩余课次</span><strong class="cd-accent">{{balanceTimes}}<small> 次</small></strong></div></section>
                  <section class="cd-panel cd-enroll">
                    <div class="cd-section-heading"><h3>添加班级学员</h3></div>
                    <div class="cd-enroll-fields" :class="{'cd-enroll-cash':classModel.consumeType=='2'}">
                      <v-autocomplete :items="notInClassStudentList" v-model="addStudent.studentId" item-text="studentName" item-value="id" label="选择学员" dense outlined hide-details no-data-text="暂无可添加学员" color="#d9363e" />
                      <v-text-field v-if="classModel.consumeType=='2'" v-model="addStudent.consumePrice" label="课时价格" suffix="元" dense outlined hide-details color="#d9363e" />
                      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto"><template v-slot:activator="{ on, attrs }"><v-text-field v-model="addStudent.joinDate" label="进班日期" readonly v-bind="attrs" v-on="on" dense outlined hide-details color="#d9363e" append-icon="mdi-calendar-blank-outline" /></template><v-date-picker v-model="addStudent.joinDate" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu>
                      <v-btn @click="addToClass" depressed dark color="#d9363e" height="40"><v-icon left small>mdi-plus</v-icon>加入班级</v-btn>
                    </div>
                  </section>
                  <section class="cd-panel cd-members">
                    <div class="cd-section-heading"><h3>正常学员 <span class="cd-count">{{normalStudentList.length}} 人</span></h3><span class="cd-muted">点击姓名查看学员班级详情</span></div>
                    <div class="cd-student-grid">
                      <article v-for="(item,index) in normalStudentList" :key="item.id || index" class="cd-student">
                        <div class="cd-student-top"><button v-if="item.studentAvatar" type="button" class="cd-avatar" :aria-label="'查看'+item.studentName+'头像'" @click="showImageViewer(item.studentAvatar)"><v-avatar size="40"><v-img :src="imgPrev+item.studentAvatar" /></v-avatar></button><span v-else class="cd-avatar cd-avatar-fallback">{{(item.studentName || '学').slice(0,1)}}</span><button type="button" class="cd-student-name" @click="toShowStudentDetail(item)">{{item.studentName}}<v-icon size="16">mdi-chevron-right</v-icon></button><v-btn text small color="#64748b" :aria-label="'禁用学员'+item.studentName" @click.stop="frozenClassStudent(item)">禁用</v-btn></div>
                        <div class="cd-student-meta"><span>进班日期</span><time>{{item.joinDate || '—'}}</time></div><div v-if="item.consumeType=='2'" class="cd-student-meta"><span>消课价格</span><strong>{{item.classPrice}} 元 / 课时</strong></div>
                      </article>
                    </div>
                    <div v-if="normalStudentList.length===0" class="cd-empty"><v-icon size="30" color="#9aa8b9">mdi-account-group-outline</v-icon><p>班级暂无正式学员</p><span>可通过上方“添加班级学员”加入学员</span></div>
                    <details v-if="frozenStudentList.length" class="cd-frozen"><summary>禁用学员 <span>{{frozenStudentList.length}} 人</span><span class="cd-expand-hint">展开 / 收起</span></summary><div class="cd-student-grid"><article v-for="(item,index) in frozenStudentList" :key="item.id || index" class="cd-student cd-student-frozen"><div class="cd-student-top"><button v-if="item.studentAvatar" type="button" class="cd-avatar" :aria-label="'查看'+item.studentName+'头像'" @click="showImageViewer(item.studentAvatar)"><v-avatar size="40"><v-img :src="imgPrev+item.studentAvatar" /></v-avatar></button><span v-else class="cd-avatar cd-avatar-fallback">{{(item.studentName || '学').slice(0,1)}}</span><button type="button" class="cd-student-name" @click="toShowStudentDetail(item)">{{item.studentName}}<v-icon size="16">mdi-chevron-right</v-icon></button><v-btn text small color="#d9363e" :aria-label="'启用学员'+item.studentName" @click.stop="freeClassStudent(item)">启用</v-btn></div><div class="cd-student-meta"><span>进班日期</span><time>{{item.joinDate || '—'}}</time></div><div v-if="item.consumeType=='2'" class="cd-student-meta"><span>消课价格</span><strong>{{item.classPrice}} 元 / 课时</strong></div></article></div></details>
                  </section>
                </main>
              </div>
            </v-tab-item>
            <v-tab-item><section class="cd-panel cd-schedule"><div class="cd-section-heading"><h3>班级排课明细</h3></div><classRecordList :classId="recordList.classId" @dataChanged="getClassDetail" /></section></v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>


		<!-- 修改班级dialog -->
		<v-dialog title="修改班级" v-model="updateClass.dialog" max-width="500" persistent>
			<v-card class="cd-subdialog">
				<v-card-title>
					<span>修改班级信息</span>
					<v-spacer></v-spacer>
					<v-btn icon aria-label="关闭修改班级" @click="updateClass.dialog=false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="6">
							<v-text-field label="班级名称" v-model="updateClass.className" dense outlined></v-text-field>
						</v-col>

						<v-col cols="6">
							<v-text-field label="最大学生人数" type="number" v-model="updateClass.maxQty" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="每节课扣课时" type="number" v-model="updateClass.reduceQty" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select :items="selectRoomList" v-model="updateClass.roomId" item-text="roomName"
								item-value="id" label="上课教室" dense outlined></v-select>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select :items="selectTeacherList" v-model="updateClass.secondTeacherId" item-text="trueName"
								item-value="id" label="助教老师一" dense outlined clearable></v-select>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select :items="selectTeacherList" v-model="updateClass.thirdTeacherId" item-text="trueName"
								item-value="id" label="助教老师二" dense outlined clearable></v-select>

						</v-col>
						<v-col cols="6">
							<v-text-field label="每次课记老师绩效课节数" type="number" min="0" step="1" max="2147483647" v-model="updateClass.addTeacherClassCount" dense outlined
								hint="填非负整数，0 表示不计节。仅对之后核销的课次生效，用于绩效课节数及按上课次数提成。" persistent-hint>
							</v-text-field>
						</v-col>

					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="updateClass.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdateClass" color="#d9363e" dark>确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 修改老师dialog -->
		<v-dialog title="修改主课老师" v-model="updateTeacher.dialog" max-width="500" persistent>
			<v-card class="cd-subdialog">

				<v-card-title>
					<span>修改主课老师</span>
					<v-spacer></v-spacer>
					<v-btn icon aria-label="关闭修改老师" @click="updateTeacher.dialog=false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-select :items="selectTeacherList" v-model="updateTeacher.oldTeacherId"
								item-text="trueName" item-value="id" label="原老师" disabled dense outlined></v-select>
						</v-col>
						<v-col cols="12">
							<v-select :items="selectTeacherList" v-model="updateTeacher.newTeacherId"
								item-text="trueName" item-value="id" label="新老师" dense outlined></v-select>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="updateTeacher.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdateTeacher" color="#d9363e" dark>确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- 开启自动积分 dialog -->
		<v-dialog title="开启自动积分" v-model="autoPointDialog.show" max-width="500" persistent>
			<v-card class="cd-subdialog">

				<v-card-title>
					<span>开启自动积分</span>
					<v-spacer></v-spacer>
					<v-btn icon aria-label="关闭自动积分" @click="autoPointDialog.show=false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="每课次每人积分数" type="number" v-model="autoPointDialog.autoPointQty" dense outlined>
							</v-text-field>
						</v-col>

					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="autoPointDialog.show=false">取消</v-btn>
					<v-btn @click="submitOpenAutoPoint" color="#d9363e" dark>确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


		<!-- 修改排课时间 -->
		<updateClassTime :show="updateTime.show" :classModel="updateTime.classModel" @cancel="updateTime.show=false"
			@success="classTimeUpdated"></updateClassTime>


		<!-- 班级成员详情 -->
		<classStudentDetail :show="classStudentView.show" :classStudent="classStudentView.classStudent" @cancel="classStudentView.show=false"
			 @leave="studentLeavedClass"></classStudentDetail>

		<!-- 升班 -->
		<classUpgrade :show="classUpgradeView.show" :classModel="classUpgradeView.classModel" @cancel="classUpgradeView.show=false"
			@success="classUpgradeSuccess"></classUpgrade>

		<!-- 图片预览 -->
		<imageViewer :show="imageViewerDialog.show" :imgSrc="imageViewerDialog.imgSrc" imgWidth="400" imgHeight="400" @cancel="imageViewerDialog.show=false"></imageViewer>

	</v-container>
</template>

<script>
	import utils from "../config/utils"
	
	import classRecordList from "./class_record_list.vue"
	import updateClassTime from "./update_class_time.vue"
	import classStudentDetail from "./class_student_detail.vue"
	import classUpgrade from "./class_upgrade.vue"
	import imageViewer from "./image_viewer.vue"
	export default {
		name: "class-detail",
		components: {
			classRecordList,
			updateClassTime,
			classStudentDetail,
			classUpgrade,
			imageViewer
		},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classId: {
				type: String,
				default: ""
			}
		},
		watch: {
			show(newVal, oldVal) {
				console.log("newVal", newVal);
				this.hideShow = newVal;
				if (this.hideShow) {
					this.tab = 0;

					this.classModel = null;
					this.getClassDetail();
					this.recordList.classId = this.classId;
					
					this.addStudent.joinDate = utils.getNowDate();

					this.getClassAllStudentList();
					this.getStudentListForSelect();

				}
			}
		},
		computed: {
			balanceTimes() {
				let result = "";
				if (this.classModel) {
					let balance = parseInt(this.classModel.totalTimes) - parseInt(this.classModel.approvedTimes);
					result = balance.toString()
				}
				return result;
			},
			notInClassStudentList(){
				// 选择学员 剔除已在班级的
				let list = [];
				
				this.selectStudentList.forEach((item,index)=>{
					
					let isOK = true;
					
					this.normalStudentList.forEach((item1,index1)=>{
						if (item.id == item1.studentId){
							isOK = false;
						}
					})
					
					if (isOK){
						list.push(item);
					}
					
				})
				
				return list;
				
			}
		},
		data() {
			return {
				menu1:false,
				tab: null,
				imgPrev: "https://photo.youkeya.cn/",
				hideShow: this.show,
				classModel: null,
				studentList: [], //班级学员列表
				normalStudentList: [], //正常学员
				frozenStudentList:[],  //禁用学员
				selectStudentList: [], // 选择学员
				selectTeacherList: [],
				selectRoomList:[], // 上课教室
				addStudent: {
					studentId: "",
					consumePrice: "",
					joinDate:""
				},
				recordList: {
					classId: ""
				},
				updateClass: {
					dialog: false,
					id: "",
					className: "",
					maxQty: "",
					courseId: "",
					roomId:"",
					reduceQty:"",
					addTeacherClassCount:""
				},
				updateTime: {
					show: false,
					classModel: null
				},
				updateTeacher: {
					dialog: false,
					classId: "",
					oldTeacherId: "",
					newTeacherId: "",
					secondTeacherId:"",
					thirdTeacherId:""
				},
				classStudentView:{
					show:false,
					classStudent:null
				},
				classUpgradeView:{
					show:false,
					classModel:null
				},
				autoPointDialog:{
					show:false,
					autoPointQty:"0"
				},
				imageViewerDialog:{
					show:false,
					imgSrc:"",
				},
				
			}
		},
		mounted() {
			console.log("class-detail mounted");
		},
		methods: {
			cancel() {
				this.$emit("cancel", "");
			},
			consumeTypeName(state) {
				let stName = "未知";
				if (state === "1") {
					stName = "按课时扣费";
				} else if (state === "2") {
					stName = "按金额扣费";
				}
				return stName;
			},
			consumeTypeColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}
				return color;
			},
			openAutoPoint(){
				// 开启自动积分
				this.autoPointDialog.autoPointQty = this.classModel.autoPointQty;
				this.autoPointDialog.show= true;
				
			},
			submitOpenAutoPoint(){
				const that = this;
				let url = `/edu/class/open/auto/point`;
				
				if (!this.autoPointDialog.autoPointQty){
					this.$noty.error("请输入自动积分数");
					return
				}
				if(parseInt(this.autoPointDialog.autoPointQty)<1){
					this.$noty.error("积分数不能少于1");
					return
				}
				
				let postData = {
					classId:this.classId,
					autoPointQty: this.autoPointDialog.autoPointQty
				}
				
				this.axios.post(url,postData).then(response => {
				
					if (response.data["code"] === 200) {
				
						that.$noty.success("开启成功");
						that.classModel.autoPoint  = "1";
						that.classModel.autoPointQty  = that.autoPointDialog.autoPointQty;
						that.autoPointDialog.show = false;
					
						return
					} else {
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				})
			},
			closeAutoPoint(){
				// 关闭自动积分
				const that = this;
				let url = `/edu/class/close/auto/point/${this.classId}`;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {

						that.$noty.success("关闭成功");
						that.classModel.autoPoint  = "0";
	
						return
					} else {
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				})
				
			},
			getClassDetail() {
				console.log("获取班级详情");

				const that = this;
				let url = `/edu/class/detail/${this.classId}`;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {

						console.log(">>>>>>>>> 获取班级基本信息 start>>>>>>>>>")

						console.log("url:", url);
						console.log("res:", response.data);

						console.log(">>>>>>>>> 获取班级基本信息 end>>>>>>>>>")

						that.classModel = response.data["data"] ? response.data["data"] : [];

						that.addStudent.consumePrice = that.classModel.consumePrice;
						return
					} else {
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				})
			},
			addToClass() {
				// 给班级添加学员
				if (!this.addStudent.studentId) {
					this.$noty.error("请选择学员");
					return
				}
				
				if (!this.addStudent.joinDate) {
					this.$noty.error("请选择进班日期");
					return
				}
				

				// 如果是扣学费的 要填写单价
				if (this.classModel.consumeType == '2') {
					if (!this.addStudent.consumePrice) {
						this.$noty.error("请输入课时单价");
						return
					}
				}


				if (parseInt(this.classModel.studentQty) >= parseInt(this.classModel.maxQty)) {
					this.$noty.error("班级已满");
					return
				}

				// 提交api
				// api
				const that = this;
				let url = `/edu/class/student/create`;
				let postData = {
					shopId: this.classModel.shopId,
					classId: this.classModel.id,
					studentId: this.addStudent.studentId,
					consumePrice: this.addStudent.consumePrice,
					joinDate:this.addStudent.joinDate
				};

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");

							// 提交成功
							that.addStudent.studentId = "";
							that.addStudent.consumePrice = that.classModel.consumePrice;

							//重新加载班级学员
							that.getClassAllStudentList();

							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showUpdateTime() {
				this.updateTime.classModel = this.classModel;
				this.updateTime.show = true;
			},
			classTimeUpdated() {
				this.updateTime.show = false;
				this.getClassDetail();
			},
			showUpdateTeacher() {
				this.updateTeacher.dialog = true;
				this.updateTeacher.classId = this.classModel.id;
				this.updateTeacher.oldTeacherId = this.classModel.teacher;


				this.getTeacherListForSelect();
			},
			showUpdateClass() {
				this.updateClass.dialog = true;
				this.updateClass.id = this.classModel.id;
				this.updateClass.className = this.classModel.className;
				this.updateClass.maxQty = this.classModel.maxQty;
				this.updateClass.courseId = this.classModel.courseId;
				this.updateClass.secondTeacherId = this.classModel.secondTeacherId;
				this.updateClass.thirdTeacherId = this.classModel.thirdTeacherId;
				this.updateClass.roomId = this.classModel.roomId;
				this.updateClass.reduceQty = this.classModel.reduceQty;
				this.updateClass.addTeacherClassCount = this.classModel.addTeacherClassCount == null ? '1' : this.classModel.addTeacherClassCount;
				
				this.getTeacherListForSelect();
				
				this.getRoomListForSelect();

			},
			toShowStudentDetail(item){
				console.log(item);
				this.classStudentView.classStudent = item;
				this.classStudentView.show=true;
			},
			submitUpdateClass() {

				if (!this.updateClass.className) {
					this.$noty.error('班级名称不能为空');
					return
				}
				if (!this.updateClass.maxQty) {
					this.$noty.error('班级人数不能为空');
					return
				}
				if (!this.updateClass.roomId) {
					this.$noty.error('教室不能为空');
					return
				}
				if (!this.updateClass.reduceQty) {
					this.$noty.error('扣课时数不能为空');
					return
				}
				if (!utils.isInt(this.updateClass.reduceQty)){
					this.$noty.error('扣课时数格式错误');
					return
				}
				
				if (this.updateClass.addTeacherClassCount == null || String(this.updateClass.addTeacherClassCount).trim() === '') {
					this.$noty.error('记老师绩效节数不能为空');
					return
				}
				if (!utils.isInt(this.updateClass.addTeacherClassCount) || Number(this.updateClass.addTeacherClassCount) > 2147483647){
					this.$noty.error('记老师绩效节数格式错误');
					return
				}
				
				// 选择了助教一
				if (this.updateClass.secondTeacherId && this.updateClass.secondTeacherId != '0') {
					if (this.updateClass.secondTeacherId == this.classModel.teacher){
						this.$noty.error('助教老师一不能和主课老师相同');
						return
					}
				}
				
				//选择了助教二
				if (this.updateClass.thirdTeacherId && this.updateClass.thirdTeacherId != '0') {
					if (!this.updateClass.secondTeacherId) {
						this.$noty.error('请先选择助教老师一');
						return
					}
					
					if (this.updateClass.thirdTeacherId == this.classModel.teacher){
						this.$noty.error('助教老师二不能和主课老师相同');
						return
					}
					
					if (this.updateClass.thirdTeacherId == this.updateClass.secondTeacherId){
						this.$noty.error('助教老师二不能和助教老师一相同');
						return
					}
				}
				
				
				// api
				const that = this;
				let url = `/edu/class/update`;

				const updateData = {
					...this.updateClass,
					addTeacherClassCount: String(this.updateClass.addTeacherClassCount)
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.updateClass.dialog = false;

							this.getClassDetail();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showUpgradeView(){
				// 显示升班控件
				this.classUpgradeView.classModel = this.classModel;
				this.classUpgradeView.show = true;
				
			},
			classUpgradeSuccess(){
				this.getClassDetail();
				this.getClassAllStudentList();
				this.classUpgradeView.show = false;
				
			},
			showImageViewer(imgSrc){
				this.imageViewerDialog.imgSrc = imgSrc;
				console.log(imgSrc);
				this.imageViewerDialog.show=true;
			},
			submitUpdateTeacher() {
				//  修改班级老师
				if (!this.updateTeacher.classId) {
					this.$noty.error('班级ID不能为空');
					return
				}
				if (!this.updateTeacher.newTeacherId) {
					this.$noty.error('新的老师不能为空');
					return
				}
				
				if (this.updateTeacher.newTeacherId == this.classModel.teacher){
					this.$noty.error('新的老师不能和原老师相同');
					return
				}

				// api
				const that = this;
				let url = `/edu/class/teacher/update`;

				// parameters
				const updateData = {
					classId: this.updateTeacher.classId,
					newTeacherId: this.updateTeacher.newTeacherId
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.updateTeacher.dialog = false;
							that.getClassDetail();

							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			frozenClass() {
				//冻结
				const that = this;
				let url = `/edu/class/frozen/${this.classId}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getClassDetail();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			freeClass() {
				//冻结
				const that = this;
				let url = `/edu/class/free/${this.classId}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getClassDetail();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			studentLeavedClass(){
				// 学员退班
				this.classStudentView.show = false;
				this.getClassDetail();
				this.getClassAllStudentList();
			},
			frozenClassStudent(item){
				// 禁用
				const that = this;
				let url = `/edu/class/student/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("禁用班级学员成功");
							that.getClassDetail();
							that.getClassAllStudentList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
							
				});
				
				
			},
			freeClassStudent(item){
				// 启用 班级学员
				const that = this;
				let url = `/edu/class/student/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("启用班级学员成功");
							that.getClassDetail();
							that.getClassAllStudentList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
				this.getClassDetail();
				this.getClassAllStudentList();
			},
			
			getTeacherListForSelect() {

				const shopId = utils.getCurrentShopId();
				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassAllStudentList() {

				const classId = this.classId;
				// 获取班级学生列表
				if (!classId) {
					return
				}

				const that = this;
				let url = `/edu/class/student/list/` + classId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.studentList = response.data["data"] ? response.data["data"] : [];

						that.normalStudentList = [];
						that.frozenStudentList = [];
						that.studentList.forEach((item, index) => {
							if (item.status == '1') {
								that.normalStudentList.push(item);
							}else if (item.status =='0'){
								that.frozenStudentList.push(item);
							}
						})

						return
					} else {
						that.$noty.error("获取失败32：" + response.data["message"]);
					}


				})
			},
			getStudentListForSelect() {

				const shopId = utils.getCurrentShopId();
				// 获取校区学生列表
				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/student/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					} else {
						that.$noty.error("获取失败55：" + response.data["message"]);
					}


				})
			},
			getRoomListForSelect() {
			
				const shopId = utils.getCurrentShopId();
				// 获取校区学生列表
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/classroom/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectRoomList = response.data["data"] ? response.data["data"] : [];
						return
					} else {
						that.$noty.error("获取失败55：" + response.data["message"]);
					}
			
			
				})
			},
		}
	}
</script>

<style lang="scss" scoped src="../assets/styles/class-detail.scss"></style>
